import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-confirmation-email',
  templateUrl: './confirmation-email.component.html',
  styleUrl: './confirmation-email.component.scss'
})
export class ConfirmationEmailComponent {

}
